var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","duration":_vm.duration},on:{"enter":function($event){_vm.show=false}}},[(_vm.show)?_c('div',{staticClass:"dtmf-key-mask"},[_vm._v(" "+_vm._s(_vm.keyPressed)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }